import bin from "./images/bin.svg";
import arrow from "./images/arrow.svg";
import { deleteSoundTracksThunk } from "../features/SoundTracksReducer";
import { useDispatch } from "react-redux"
import { deleteUserPostThunk } from "../features/PostManagementReducer";
import { updateReportManagementThunk } from "../features/ReportManagementReducer";


import { updateCashOutThunk } from "../features/CashOutReducer";

import { Tooltip } from 'antd';
import { confirmAlert } from 'react-confirm-alert';
import { updateUserManagementThunk } from "../features/UserManagementReducer";
import { useState } from "react";
import { deleteAdminTracksThunk } from "../features/AdminTrackReducer";
import { deleteUserReportedPostThunk } from "../features/PostReportReducer";

import DeleteModal from "../components/Modal/DeleteModal";
import "./styles/Alert.css";
import AlertModal from "../components/Modal/AlertModal";

export function submit(title, message, cb, rejectCB = () => { }) {
    confirmAlert({
        title,
        message,
        buttons: [
            {
                label: 'Yes',
                onClick: () => cb()
            },
            {
                label: 'No',
                onClick: () => rejectCB()
            }
        ],
        closeOnEscape: true,
        closeOnClickOutside: true,
        keyCodeForClose: [8, 32],
    });
}
export function submitDelete(title, message, cb, rejectCB = () => { }) {
    confirmAlert({
        customUI: ({ onClose }) => {
            return (
                <DeleteModal
                    handleClose={onClose}
                    handleDelete={() => {
                        cb();
                        onClose();
                    }}

                />
            );
        },
        overlayClassName: "confirm-alert-background-change"
    });
}

export function submitAlert(title, message, cb, rejectCB = () => { }) {
    confirmAlert({
        customUI: ({ onClose }) => {
            return (
                <AlertModal
                    text={message}
                    handleClose={onClose}
                    handleDelete={() => {
                        cb();
                        onClose();
                    }}

                />
            );
        },
        overlayClassName: "confirm-alert-background-change"
    });
}

export function useUserManagementHeader() {

    const dispatch = useDispatch();
    return [
        {
            title: 'Username',
            render: (record, val) => {
                return <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={val.image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px" }}>{val.username}</p>

                </div>
            }
        },
        {
            title: 'Full Name',
            dataIndex: 'name',

        },
        {
            title: 'Email Address',
            dataIndex: 'email',
        },
        {
            title: 'Phone Number',
            dataIndex: 'mobile_no',
        },
        {
            title: 'Status',
            width: 170,
            key: 'action',
            render: (record) => {
                const status = (record.online_status == "0") ? 'unblock' : 'block';
                return <div
                    onClick={() =>
                        submitAlert("Change Status", `Are you sure you want to ${status} this user?`, () => dispatch(updateUserManagementThunk({ slug: record.slug, online_status: record.online_status == "0" ? "1" : "0" })))}
                    style={{ width: "100%", cursor: "pointer", background: "black", padding: "3px 15px", display: "flex", alignItems: "center" }}>
                    <a
                        style={{ width: "100%", color: "#7BE35C", marginRight: "30px", color: (record.online_status != "0") ? "#7BE35C" : "#CB0C51" }}>{record.online_status != "0" ? "Active" : "Deactive"}</a>
                    <img src={arrow} alt="Arrow" width={20} height={20} />
                </div>
            },
        },
    ];
}

export function useSoundTracksHeader(setIsListed, setSoundTrackList) {

    const header = [
        {
            title: "Username",
            render: (record, val) => {
                return <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={val.image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px" }}>{val.username}</p>

                </div>
            }
        },
        {
            title: "Email Address",
            dataIndex: "email"
        }, {
            title: "Soundtracks",
            render: (val) => {
                return <a onClick={() => {
                    setSoundTrackList(val.track_list)
                    setIsListed(false)
                }}>View Listings</a>
            }
        }
    ]

    return header;
}

export function useListingHeader(setSoundTrackList, setFile) {
    const dispatch = useDispatch();
    const header = [
        {
            title: "Track Name",
            render: (record, val) => {
                return <div style={{ display: "inline-flex", flexDirection: "row", alignItems: "center", width: "auto", cursor: 'pointer' }} onClick={() => setFile({ path: record.audio_url, type: 'audio' })}>
                    <img src={require("./images/rect.png")} alt="User Image" style={{ width: "30px", height: "30px" }} />
                    <p style={{ color: "white", margin: "0 15px" }}>{val.track_name}</p>

                </div>
            }
        },
        {
            title: "Artist",
            dataIndex: "track_artist"
        },
        {
            title: "Length",
            dataIndex: "duration"
        },
        {
            title: "Actions",
            width: 200,
            textWrap: 'word-break',
            render: (val, record) => {
                return <div
                    style={{ display: "flex", flexDirection: "row", color: "#CB0C51", alignItems: "center", cursor: "pointer" }}
                    onClick={() => submitDelete("Confirm Deletion", "Are you sure you want to delete?", () => dispatch(deleteSoundTracksThunk({ audio_slug: val.audio_slug, setSoundTrackList })))}
                >
                    <img src={bin} alt="" />
                    <p style={{ margin: "0 10px" }} >Delete</p>
                </div>
            }
        }
    ]
    return header
}

export function useAdminTracksHeader(setFile) {
    const dispatch = useDispatch();
    const header = [
        {
            title: "Track Name",
            render: (record, val) => {
                return <div style={{ display: "inline-flex", flexDirection: "row", alignItems: "center", width: "auto", cursor: 'pointer' }} onClick={() => setFile({ path: record.audio_url, type: 'audio' })}>
                    <img src={require("./images/rect.png")} alt="User Image" style={{ width: "30px", height: "30px" }} />
                    <p style={{ color: "white", margin: "0 15px" }}>{val.track_name}</p>

                </div>
            }
        },
        {
            title: "Artist",
            dataIndex: "track_artist"
        },
        {
            title: "Length",
            dataIndex: "duration"
        },
        {
            title: "Actions",
            width: 200,
            textWrap: 'word-break',
            render: (val, record) => {
                return <div
                    style={{ display: "flex", flexDirection: "row", color: "#CB0C51", alignItems: "center", cursor: "pointer" }}
                    onClick={() => submitDelete("Confirm Deletion", "Are you sure you want to delete?", () => dispatch(deleteAdminTracksThunk({ audio_slug: val.slug })))}
                >
                    <img src={bin} alt="" />
                    <p style={{ margin: "0 10px" }} >Delete</p>
                </div>
            }
        }
    ]
    return header
}

export function usePostManagementHeader(setIsListed, setSoundTrackList) {
    const header = [
        {
            title: "Username",
            render: (record, val) => {
                return <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={val.image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px" }}>{val.username}</p>

                </div>
            }
        },
        {
            title: "Email Address",
            dataIndex: "email"
        }, {
            title: "Listings",
            render: (val) => {
                return <a onClick={() => {
                    setSoundTrackList(val.post_list)
                    setIsListed(false)
                }}>View Listings</a>
            }
        }
    ]

    return header;
}



export function usePostListingHeader(setUserPostList, setFile) {
    const dispatch = useDispatch();


    const header = [
        {
            title: "Thumbnail",
            render: (record, val) => {
                return <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={record.thumbnail_url} alt="User Image" style={{ width: "30px", height: "30px", cursor: 'pointer' }} onClick={() => setFile({ path: record.video_url, type: 'video' })} />

                </div>
            }
        },
        {
            title: "Description",
            dataIndex: "description"
        },
        {
            title: "Privacy",
            render: (record, val) => {
                return <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <p style={{ margin: 0 }}>{record.isPrivate ? "Private" : "Public"}</p>
                </div>
            }
        },
        {
            title: "Views",
            align: "center",
            dataIndex: "views",

        },
        {
            title: "Likes",
            align: "center",
            dataIndex: "likes"
        },
        {
            title: "Actions",
            width: 200,
            textWrap: 'word-break',
            render: (val, record) => {
                return <div
                    style={{ display: "flex", flexDirection: "row", color: "#CB0C51", alignItems: "center", cursor: "pointer" }}
                    onClick={() => submitDelete("Confirm Deletion", "Are you sure you want to delete?", () => dispatch(deleteUserPostThunk({ post_slug: val.post_slug, setUserPostList })))}
                >
                    <img src={bin} alt="" />
                    <p style={{ margin: "0 10px" }} >Delete</p>
                </div>
            }
        }
    ]
    return header
}

export function useCashOutRequestsHeader() {
    const dispatch = useDispatch();
    const [value, setValue] = useState("pending");


    function handleChange(e) {
        const { value } = e.currentTarget;
        if (value != "pending") {
            submitAlert("Confirm Cashout", `Are you sure you want to ${JSON.parse(value).status}?`, () => dispatch(updateCashOutThunk(value)), () => { });
        }
    }

    const header = [
        {
            title: 'Username',
            dataIndex: "fullname",
            render: (record, val) => {
                return <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={val.image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px" }}>{val.username}</p>

                </div>
            }
        },
        {
            title: 'Email Address',
            dataIndex: 'email',
        },
        {
            title: 'Coins',
            align: 'center',
            render: (record) => <p>{`${record.amount}`}</p>
        },
        {
            title: 'Total Amount',
            align: 'center',
            render: (record) => <p>{`$${record.total_amount}`}</p>
        },
        {
            title: 'Date',
            dataIndex: 'date',
        },
        {
            title: 'Status',
            width: 170,
            key: 'action',
            render: (record) => {
                const { status } = record;
                return status != "pending" ? <div style={{ width: "100%", background: "black", textAlign: "center", padding: "3px 15px", display: "flex", alignItems: "center" }}>
                    <a style={{ width: "100%", color: status === "approved" ? "#7BE35C" : "#CB0C51" }}>{status === 'approved' ? 'Approved' : 'Disapproved'}</a>
                </div>
                    : <select value={value}
                        onChange={handleChange}
                        placeholder="pending" style={{ width: "100%", cursor: "pointer", background: "black", padding: "3px 15px", wordWrap: 'break-word', wordBreak: 'break-word', display: "flex", alignItems: "center", color: "grey", cursor: "pointer" }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <option value="pending">Pending</option>
                        <option value={JSON.stringify({ ...record, status: "approved" })}>Approved</option>
                        <option value={JSON.stringify({ ...record, status: "disapproved" })}>Disapproved</option>
                    </select>
            },
        },
    ];
    return header;
}
{/*  */ }
export function useReportManagementHeader() {
    const dispatch = useDispatch();
    const header = [
        {
            title: 'Reporter',
            render: (record) => {
                return <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={record.source_image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px" }}>{record.source_username}</p>

                </div>
            }
        },
        {
            title: 'Reporter Email',
            dataIndex: 'source_email',
        },
        {
            title: 'Reportee Username',
            render: (record) => {
                return <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={record.target_image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px" }}>{record.target_username}</p>

                </div>
            }
        },
        {
            title: 'Reportee Email',
            dataIndex: 'target_email',
        },
        {

            title: 'Reason',
            dataIndex: 'reason',
            ellipsis: {
                showTitle: false,
            },
            render: (text) => (
                <Tooltip placement="bottom" title={text} overlayStyle={{ width: "auto", maxWidth: "40vw" }}>
                    {(text.length > 10) ? `${text.slice(0, 15)}...` : text}
                </Tooltip>
            ),
        },
        {
            title: 'Date',
            width: 250,
            ellipsis: true,
            dataIndex: 'date',
        },
        {
            title: 'Status',
            width: 170,
            key: 'action',
            render: (record, val) => {
                const status = (record.status === "block") ? "unblock" : "block";
                const data = {
                    user_slug: record.source_user_slug,
                    target_user_slug: record.target_user_slug,
                    status: record.status === "block" ? "unblock" : "block",
                }
                return <div
                    style={{ width: "100%", cursor: "pointer", background: "black", padding: "3px 15px", display: "flex", alignItems: "center" }}
                    onClick={() => submitAlert("Change Status", `Are you sure you want to ${status} the user?`, () => dispatch(updateReportManagementThunk(data)))}
                >
                    {val.status === "unblock" ?
                        < a style={{ width: "100%", color: "#7BE35C" }}>Unblock</a> :
                        < a style={{ width: "100%", color: "#CB0C51" }}>Block</a>
                    }
                    <img src={arrow} alt="Arrow" width={20} height={20} style={{ marginLeft: "20px" }} />
                </div>
            },
        },
    ];
    return header;

}

export const SubscriptionHeader = [
    {
        title: 'Username',
        dataIndex: "fullname",
        render: (record, val) => {
            return <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                <img src={require("./images/profile.png")} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                <p style={{ color: "white", margin: "0 15px" }}>{val.fullname}</p>

            </div>
        }
    },
    {
        title: 'Subscription Date',
        dataIndex: 'date',
    },
    {

        title: 'Package',
        dataIndex: 'package',
    },
    {

        title: 'Package Amount',
        dataIndex: 'amount',
    }, {

        title: 'Expiry Date',
        dataIndex: 'expiryDate',
    },
];



export function useSubscriptionHeader(setIsListed, setSubscriptionList) {

    const header = [
        {
            title: "Username",
            render: (record, val) => {
                return <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={val.image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px" }}>{val.username}</p>

                </div>
            }
        },
        {
            title: "Email Address",
            dataIndex: "email"
        }, {
            title: "Subscriptions",
            render: (val) => {
                return <a onClick={() => {
                    setSubscriptionList(val.subscription_list)
                    setIsListed(false)
                }}>View Listings</a>
            }
        }
    ]

    return header;
}

export function useUsersSubscriptionsHeader() {
    const dispatch = useDispatch();
    const header = [
        {
            title: "Start Date",
            dataIndex: "start_date",
        },
        {
            title: "Time Period",
            dataIndex: "time_period",
            align: "center",
        },
        {
            title: "package",
            align: "center",
            render: (record) => {
                return <p style={{ margin: 0 }}>{record.amount}</p>
            },
        },
        {
            title: "End Date",
            dataIndex: "end_date",
        },
        {
            title: "Status",
            width: 220,
            textWrap: 'word-break',
            align: "center",
            render: (record) => {
                return <div style={{ width: "100%", background: "black", textAlign: "center", padding: "3px 15px", display: "flex", alignItems: "center" }}>
                    <a style={{ width: "100%", color: "#7BE35C", color: (record.status == "active") ? "#7BE35C" : "#CB0C51" }}>{record.status == "active" ? 'Active' : 'Expired'}</a>
                </div>
            },
        },

    ]
    return header
}



export function useUserDonateHeader(setIsListed, setUserDonateList) {
    const header = [
        {
            title: "Username",
            render: (record) => {

                return <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={record.image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px" }}>{record.name}</p>

                </div>
            }
        },
        {
            title: "Email Address",
            dataIndex: "email"
        }, {
            title: "Listings",
            render: (record) => {
                return <a onClick={() => {
                    setUserDonateList({
                        sent: record.sent,
                        recieved: record.recieved
                    })
                    setIsListed(false)
                }}>View Listings</a>
            }
        }
    ]

    return header;
}



export function useUserDonateListing() {


    const header = [
        {
            title: "Donated By",
            render: (record, val) => {
                return <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={record.donatedBy_image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px" }}>{record.donatedBy_name}</p>

                </div>
            }
        },
        {
            title: "Donated To",
            render: (record, val) => {
                return <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={record.donatedTo_image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px" }}>{record.donatedTo_name}</p>

                </div>
            }
        },
        {
            title: "Coins",
            dataIndex: "coins"
        },
        {
            title: "Donated At",
            dataIndex: "created_at"
        },

    ]
    return header
}



export function usePostReportListingHeader(setIsListed, setPostReportList, setFile) {
    const dispatch = useDispatch();
    const header = [
        {
            title: "Owner Name",
            render: (record, val) => {
                return <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={val.owner_image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px" }}>{val.owner_name}</p>

                </div>
            }
        },
        {
            title: "Post Details",
            render: (record, val) => {
                return <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={record.post_thumbnail_url} alt="User Image" style={{ width: "30px", height: "30px", cursor: 'pointer' }} onClick={() => setFile({ path: record.post_video_url, type: 'video' })} />

                </div>
            }
        },
        {
            width: 200,
            render: (val) => {
                return <a onClick={() => {
                    setPostReportList(val.report_list)
                    setIsListed(false)
                }}>View Listings</a>
            }
        },
        {
            width: 200,
            textWrap: 'word-break',
            render: (val, record) => {
                return <div
                    style={{ display: "flex", flexDirection: "row", color: "#CB0C51", alignItems: "center", cursor: "pointer" }}
                    onClick={() => submitDelete("Confirm Deletion", "Are you sure you want to permanently delete this post?", () => dispatch(deleteUserReportedPostThunk({ post_slug: val.post_slug })))}
                >
                    <img src={bin} alt="" />
                    <p style={{ margin: "0 10px" }} >Delete</p>
                </div>
            }
        }
    ]
    return header
}



export function usePostReportUserListing(setFile) {
    const dispatch = useDispatch();
    const header = [
        {
            title: "Reporter Name",
            render: (record, val) => {
                return <div style={{ display: "inline-flex", flexDirection: "row", alignItems: "center", width: "auto", cursor: 'pointer' }}>
                    <img src={val.user_image_url} alt="User Image" style={{ width: "30px", height: "30px" }} />
                    <p style={{ color: "white", margin: "0 15px" }}>{val.user_name}</p>

                </div>
            }
        },
        {
            title: "Reason",
            dataIndex: "comments",
            render: (text) => {
                return <Tooltip placement="bottom" title={text} overlayStyle={{ width: "auto", maxWidth: "40vw" }}><p style={{
                    margin: 0, WebkitBoxOrient: "vertical", WebkitLineClamp: 1,
                    overflow: "hidden",
                    display: "-webkit-box",
                    textOverflow: "ellipsis"
                }}> {text}</p>
                </Tooltip>
            }
        },
        {
            title: "Reported On",
            dataIndex: "created_at"
        },

    ]
    return header
}
